export default __webpack_public_path__ + "static/cointelegraph-240-05b607d56ec158fe122bc63a34fd7ab2.png";